import { render, staticRenderFns } from "./EcardTemplateFontsFilter.vue?vue&type=template&id=3e066402&"
import script from "./EcardTemplateFontsFilter.vue?vue&type=script&lang=js&"
export * from "./EcardTemplateFontsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports